import React, { useEffect, useState  } from 'react';
import { Box, BottomNavigation, BottomNavigationAction} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';

const MenuComponent = ({selectedMenu, setSelectedMenu}) => {
    return (
        <Box sx={{ width: '100vw', position: 'absolute', bottom: 0, left: 0, borderTop: '1px solid black' }}>
            <BottomNavigation
                showLabels
                value={selectedMenu}                
                onChange={(event, newValue) => {
                    setSelectedMenu(newValue);
                }}
            >
                <BottomNavigationAction label="Dashboard" icon={<DashboardIcon />} />
                <BottomNavigationAction label="Report" icon={<SignalCellularAltIcon />} />
            </BottomNavigation>
        </Box>
    )
}

export default MenuComponent;